// Lista oficial das Comissões da OAB/MS (valor + legenda), usada no campo de
// seleção do pedido de Inscrição para Comissões (tipo Advogado). O "value" é o
// código numérico oficial da comissão — hoje só fica salvo no formData; a API
// de Protocolo ainda não tem campo pra receber esse valor no momento da criação
// do requerimento (isso deve ser adicionado no futuro).
export const COMISSOES_OAB_MS = [
  { value: '01', label: 'COMISSÃO DE FISCALIZAÇÃO DA ATIVIDADE PROFISSIONAL DA ADVOCACIA - CPFAPA' },
  { value: '02', label: 'COMISSÃO DA ADVOCACIA CRIMINAL - CAC' },
  { value: '03', label: 'COMISSÃO DE INCENTIVO À PRODUÇÃO CIENTÍFICA E JURÍDICA NO MS - CIPCJ' },
  { value: '04', label: 'COMISSÃO DE COMBATE À VIOLÊNCIA DOMÉSTICA E FAMILIAR CONTRA A MULHER - COMCEVID' },
  { value: '05', label: 'COMISSÃO DE ASSUNTOS AGRÁRIOS E AGRONEGÓCIO - CAAA' },
  { value: '06', label: 'COMISSÃO PERMANENTE DE ASSUNTOS INDÍGENAS - COPAI' },
  { value: '07', label: 'COMISSÃO DE TRANSPARÊNCIA E PROBIDADE PÚBLICA - CTPP' },
  { value: '08', label: 'COMISSÃO DO MEIO AMBIENTE - COMAM' },
  { value: '09', label: 'COMISSÃO DA MULHER ADVOGADA - CMA' },
  { value: '10', label: 'COMISSÃO DE DEFESA DOS DIREITOS DO CONSUMIDOR - CDDC' },
  { value: '11', label: 'COMISSÃO DE PROCESSO CIVIL - CPC' },
  { value: '12', label: 'COMISSÃO DE DIREITO PREVIDENCIÁRIO - CDP' },
  { value: '13', label: 'COMISSÃO DA ADVOCACIA TRABALHISTAS - CAT' },
  { value: '14', label: 'COMISSÃO DA ADVOCACIA PÚBLICA - CAP' },
  { value: '15', label: 'COMISSÃO DE SOCIEDADE DE ADVOGADOS - CSA' },
  { value: '16', label: 'COMISSÃO DE EDUCAÇÃO JURÍDICA - CEJ' },
  { value: '17', label: 'COMISSÃO DE DIREITOS SOCIAIS - CDS' },
  { value: '18', label: 'COMISSÃO DE DEFESA DOS DIREITOS HUMANOS - CDH' },
  { value: '19', label: 'COMISSÃO DE DIREITO MINERÁRIO E DA MINERAÇÃO - CDMM' },
  { value: '20', label: 'COMISSÃO DE DEFESA E ASSISTÊNCIA DAS PRERROGATIVAS DOS ADVOGADOS - CDA' },
  { value: '21', label: 'COMISSÃO DE ESTÁGIO E EXAME DE ORDEM - CEEO' },
  { value: '22', label: 'COMISSÃO DA JOVEM ADVOCACIA - CJA' },
  { value: '23', label: 'COMISSÃO DE ASSUNTOS TRIBUTÁRIOS - CATRI' },
  { value: '24', label: 'COMISSÃO ESPECIAL DE DIREITO DE INTEGRAÇÃO DA ROTA BIOCEÂNICA – ROTA DE INTEGRAÇÃO LATINO AMERICANA - CEDIRB-RILA' },
  { value: '25', label: 'COMISSÃO DE PROCESSO CIVIL - CPC' },
  { value: '26', label: 'COMISSÃO ESPECIAL DE DIREITO SEGURITÁRIO - CDIRS' },
  { value: '27', label: 'COMISSÃO DE DIREITO DA FAMÍLIA - CDFAM' },
  { value: '28', label: 'COMISSÃO DE DIREITO MÉDICO, SANITÁRIO E DEFESA DA SAÚDE - CDMDS' },
  { value: '29', label: 'COMISSÃO ESPECIAL DE REGULARIZAÇÃO FUNDIÁRIA - CERF' },
  { value: '30', label: 'COMISSÃO DO DIREITO SISTÊMICO - CDSIS' },
  { value: '31', label: 'COMISSÃO DE DEFESA DOS DIREITOS DOS ANIMAIS - CDDA' },
  { value: '32', label: 'COMISSÃO DE ESTUDO E ACOMPANHAMENTO DA LEI GERAL DE PROTEÇÃO DOS DADOS E SEGURANÇA DA INFORMAÇÃO - CEA-LGPD' },
  { value: '33', label: 'COMISSÃO TEMPORÁRIA DE EXECUÇÃO PENAL - CEXP' },
  { value: '34', label: 'COMISSÃO DE DEFESA DOS DIREITOS DA CRIANÇA E DO ADOLESCENTE - CDCA' },
  { value: '35', label: 'COMISSÃO TEMPORÁRIA DE DEFESA DOS DIREITOS DA PESSOA COM AUTISMO - CDPA' },
  { value: '36', label: 'COMISSÃO DE DIREITO DA FAMÍLIA - CDFAM' },
  { value: '37', label: 'COMISSÃO DE DIREITO PENAL - CDPEN' },
  { value: '38', label: 'COMISSÃO ESPECIAL DOS ADVOGADOS CORRESPONDENTES - CEAC' },
  { value: '39', label: 'COMISSÃO DE DIREITO MILITAR - CDM' },
  { value: '40', label: 'COMISSÃO DE DEFESA DOS DIREITOS DOS ANIMAIS - CDDA' },
  { value: '41', label: 'COMISSÃO DO ADVOGADO PUBLICISTA - CAPUB' },
  { value: '42', label: 'COMISSÃO DA CULTURA - CCULT' },
  { value: '43', label: 'COMISSÃO ESPECIAL DE ENERGIA - CEE' },
  { value: '44', label: 'COMISSÃO DE PROPRIEDADE INTELECTUAL - CPI' },
  { value: '45', label: 'COMISSÃO DE SEGURANÇA PÚBICA - CSP' },
  { value: '46', label: 'COMISSÃO TEMPORÁRIA DE ASSUNTOS DE DEFESA E ESTUDOS ESTRATÉGICOS - CADEE' },
  { value: '47', label: 'COMISSÃO DE DIREITO MINERÁRIO E DA MINERAÇÃO - CDMM' },
  { value: '48', label: 'COMISSÃO DE DIREITO PREVIDENCIÁRIO - CDP' },
  { value: '49', label: 'COMISSÃO PERMANENTE DE ASSUNTOS INDÍGENAS - COPAI' },
  { value: '50', label: 'COMISSÃO DE TRÂNSITO - CT' },
  { value: '51', label: 'COMISSÃO DOS DIREITOS DA PESSOA IDOSA - CDPI' },
  { value: '52', label: 'COMISSÃO DOS DIREITOS DA PESSOA COM DEFICIÊNCIA E DA ACESSIBILIDADE - CPDA' },
  { value: '53', label: 'COMISSÃO DE FALÊNCIA E RECUPERAÇÃO JUDICIAL - CFRJ' },
  { value: '55', label: 'COMISSÃO DE SOCIEDADE DE ADVOGADOS - CSA' },
  { value: '56', label: 'COMISSÃO DE CIBERSEGURANÇA, FRAUDES E CRIMES VIRTUAIS - COM-CSFV' },
  { value: '57', label: 'COMISSÃO DE ACADÊMICOS E ESTAGIÁRIOS DE DIREITO - CAED' },
  { value: '58', label: 'COMISSÃO DE DIREITO DESPORTIVO - CDD' },
  { value: '59', label: 'COMISSÃO TEMPORÁRIA DE ASSUNTOS DE DEFESA E ESTUDOS ESTRATÉGICOS - CADEE' },
  { value: '60', label: 'COMISSÃO DE DIVERSIDADE SEXUAL E GÊNERO - CDSG' },
  { value: '61', label: 'COMISSÃO DO DIREITO DAS PESSOAS COM DEFICIÊNCIA E DA ACESSIBILIDADE - CPDA' },
  { value: '62', label: 'COMISSÃO DOS DIREITOS DA PESSOA IDOSA - CDPI' },
  { value: '63', label: 'COMISSÃO DE TRÂNSITO - CT' },
  { value: '64', label: 'COMISSÃO DE RELAÇÕES INTERNACIONAIS E INSTITUCIONAIS - CRII' },
  { value: '65', label: 'COMISSÃO DE DIREITO REGISTRAL E NOTARIAL - CDRN' },
  { value: '66', label: 'COMISSÃO DE DIREITO IMOBILIÁRIO E URBANÍSTICO - CDIUR' },
  { value: '67', label: 'COMISSÃO TEMPORÁRIA DE ESTUDOS DO PORTE DE ARMA PARA ADVOGADOS - CPA' },
  { value: '68', label: 'COMISSÃO DE LEGAL OPERATIONS - CLO' },
  { value: '69', label: 'COMISSÃO DE DIREITOS DAS SUCESSÕES - CDSU' },
  { value: '70', label: 'COMISSÃO TEMPORÁRIA DE COMPLIANCE E GOVERNANÇA - COMCOMPLIANCE' },
  { value: '71', label: 'COMISSÃO DE DIREITO EMPRESARIAL - CDE' },
  { value: '72', label: 'COMISSÃO DE CELERIDADE PROCESSUAL - CCP' },
  { value: '73', label: 'COMISSÃO ESPECIAL DOS ADVOGADOS CORRESPONDENTES - CEAC' },
  { value: '74', label: 'COMISSÃO DE DIREITO ELEITORAL - CDEL' },
  { value: '75', label: 'COMISSÃO ESPECIAL DE DIREITO BANCÁRIO - CDIRB' },
  { value: '76', label: 'COMISSÃO DE PRECATÓRIOS - CP' },
  { value: '77', label: 'COMISSÃO DO TERCEIRO SETOR - CTS' },
  { value: '78', label: 'COMISSÃO DE MARKETING JURÍDICO - CMJ' },
  { value: '79', label: 'COMISSÃO DE DIREITO DIGITAL E STARTUP - CDDS' },
  { value: '80', label: 'COMISSÃO DO DIREITO DAS PESSOAS COM DEFICIÊNCIA E DA ACESSIBILIDADE - CPDA' },
  { value: '81', label: 'COMISSÃO DE REGIME PRÓPRIO DE PREVIDÊNCIA SOCIAL - CRPPS' },
  { value: '82', label: 'COMISSÃO DE FISCALIZAÇÃO DE HONORÁRIOS ADVOCATÍCIOS - COHA' },
  { value: '83', label: 'COMISSÃO DE INOVAÇÃO E TECNOLOGIA JURÍDICA - CITJ' },
  { value: '84', label: 'COMISSÃO DO SISTEMA CARCERÁRIO - CSCAR' },
  { value: '85', label: 'COMISSÃO DE DIVERSIDADE SEXUAL E GÊNERO - CDSG' },
  { value: '86', label: 'COMISSÃO DE ACOMPANHAMENTO DOS JUIZADOS ESPECIAIS - CEAJE' },
  { value: '87', label: 'COMISSÃO DE DIREITO REGULATÓRIO - CDR' },
  { value: '88', label: 'COMISSÃO DE DIREITO DOS IMIGRANTES E REFUGIADOS - CDIR' },
  { value: '89', label: 'COMISSÃO DE IGUALDADE RACIAL - COMIR' },
  { value: '90', label: 'COMISSÃO DE ERRO E INJUSTIÇA CRIMINAL - CEIC' },
  { value: '91', label: 'COMISSÃO DE ESPORTE E LAZER - CEL' },
  { value: '92', label: 'COMISSÃO DE CONCILIAÇÃO, MEDIAÇÃO E ARBITRAGEM - CCMA' },
  { value: '93', label: 'COMISSÃO DE LEILÕES - CLE' },
  { value: '94', label: 'COMISSÃO DO TRIBUNAL DO JÚRI - CTJUR' },
  { value: '95', label: 'COMISSÃO DE ESTUDOS CONSTITUCIONAIS - CEC' },
  { value: '96', label: 'COMISSÃO DE DIREITO ECONÔMICO E COMÉRCIO EXTERIOR - CDECE' },
  { value: '97', label: 'COMISSÃO DE DIREITO ADMINISTRATIVO - CDADM' }
];
